'use strict';

function mailcheck($compile) {
  var DDO = {
    restrict: 'A',
    require: ['?ngModel', '?mailcheck'],
    scope: {
      mailcheckCallback: '&'
    },
    bindToController: {
      options: '='
    },
    controller: function () {
    },
    controllerAs: 'MC',
    link: function (scope, element, attrs, ctrls) {
      var restrictedTypes = /email|search|text/i;
      if (!attrs.ngModel) {
        throw new Error('element must contain ng-model attribute');
      }
      if (element[0].nodeName !== 'INPUT' || !restrictedTypes.test(attrs.type)) {
        throw new Error('mailcheck element is limited to text, email, search input types only');
      }

      // ctrls is an array. [0] contains ngModel, [1] contains directive's controller
      var ngModelCtrl = ctrls[0],
        MC = ctrls[1],
        result = null,
        templateStr = '<div class ="help-block mailcheck" ng-show="MC.suggestion.domain">Mente du <a ng-click="MC.correctMe(MC.suggestion.full)"><i ng-bind="MC.suggestion.full"></i></a>? <a ng-click="MC.discard()">Nei</a></div>',
        options = {
          templateStr: templateStr,
          domains: Mailcheck.defaultDomains,
          secondLevelDomains: Mailcheck.defaultSecondLevelDomains,
          topLevelDomains: Mailcheck.defaultTopLevelDomains
        };

      /* Implementation */
      MC.suggestion = false;

      element.after($compile(options.templateStr)(scope));
      element.on('blur', function () {
        options.email = ngModelCtrl.$viewValue;
        MC.suggestion = false;
        result = Mailcheck.run(options);
        scope.$evalAsync(function () {
          MC.suggestion = result;
        });
      });

      MC.discard = function () {
        scope.$evalAsync(function () {
          MC.suggestion.domain = null;
        });
      };

      MC.correctMe = function (val) {
        ngModelCtrl.$setViewValue(val);
        ngModelCtrl.$render();
        scope.$evalAsync(function () {
          MC.suggestion.domain = null;
        });
        if (scope.mailcheckCallback) {
          scope.mailcheckCallback();
        }
      };
    }
  };
  return DDO;
}

mailcheck.$inject = ['$compile'];

angular
  .module('SendRegning')
  .directive('mailcheck', mailcheck);
